import RealTimeErrorStreamPanel from "@/components/observability/RealTimeErrorStreamPanel";

export default function RealTimeFrontendErrorsPage() {
  return (
    <div className="space-y-6">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-foreground">Frontend Error Stream</h1>
        <p className="text-sm text-muted-foreground">
          Observe live browser errors as they happen. Requires the Frontend Observability capability.
        </p>
      </header>
      <RealTimeErrorStreamPanel />
    </div>
  );
}
